module.exports = __webpack_public_path__ + "static/media/image_5.7d336603.png";